export default {
  "menu.login": "登入",
  "menu.overview": "俯瞰",
  "menu.calendar": "日曆",
  "menu.projects": "專案管理",
  "menu.quality": "質量管理",
  "menu.resources": "成員視圖",
  "menu.mindmaps": "思維導圖",
  "menu.customers": "客戶 / 產品",
  "menu.holidays": "節假日",
  "menu.notifications": "通知",
  "menu.settings": "設定",
  "menu.account.logout": "登出",
};
